module.exports = __webpack_public_path__ + "static/img/body2.365a8dc.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/invitePage/body2.png
// module id = CojN
// module chunks = 14